// COMMON_CONFIG - DRY approach - being extended by separate configs
// set there options that are common for every slider
const COMMON_CONFIG = {
    mediaQuery: 'min',
    gap: '1.5rem',
};

// each key of CONFIG object represents separate slider on the site
// each slider can use his own config via [data-config] attribute

// custom options:
// @customNoDrag - enables NoDrag extension
// @customPagination - enables CustomPagination extension
const CONFIG = {
    default: {},
    ebookHome: {
        perPage: 1,
        rewind: true,
        arrows: false,
        pagination: false,
        autoplay: true,
        interval: 8000,
    },
    saloons: {
        perPage: 1,
        rewind: true,
        arrows: false,
        pagination: false,
        autoplay: true,
        // fixedWidth: '90%',
        // width: '574px',
        lazyLoad: 'sequential',
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                // perPage: 2,
                fixedWidth: '574px',
                start: 3,
            },
        },
    },
    workshop: {
        perPage: 1,
        rewind: true,
        arrows: false,
        pagination: false,
        breakpoints: {
            640: {
                perPage: 3,
            },
        },
    },
    ideas: {
        perPage: 1,
        arrows: true,
        pagination: false,
    },
    timeline: {
        perPage: 1,
        arrows: false,
        drag: false,
        pagination: false,
        customPagination: true,
        // paginationDirection: 'ttb',
    },
    homeBannerMobile: {
        type: 'fade',
        rewind: true,
        arrows: false,
        pagination: false,
        fixedHeight: '448px',
        autoplay: true,
        interval: 12000,
        customProgress: true,
        pauseOnHover: false,
    },
    homeBanner: {
        type: 'fade',
        rewind: true,
        arrows: true,
        pagination: false,
        perPage: 1,
        autoplay: true,
        interval: 12000,
        fixedHeight: '432px',
        customProgress: true,
        pauseOnHover: false,
    },
    homeCollections: {
        type: 'loop',
        fixedWidth: '224px',
        focus: 'center',
        arrows: false,
        pagination: false,
        lazyLoad: 'nearby',
        autoplay: true,
        interval: 2000,
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                perPage: 4,
                fixedWidth: '',
            },
        },
    },
    savicki5c: {
        fixedWidth: '224px',
        perPage: 1.2,
        gap: '12px',
        focus: 'start',
        loop: false,
        arrows: false,
        pagination: false,
        lazyLoad: 'nearby',
    },
    listing_submenu: {
        fixedWidth: '140px',
        // perPage: 1.2,
        // perMove: 1,
        gap: '16px',
        // focus: 'center',
        // trimSpace: true,
        loop: false,
        arrows: false,
        pagination: false,
        lazyLoad: 'nearby',
        drag: 'free',
        breakpoints: {
            [window.gridBreakpoints.md]: {
                fixedWidth: '189px',
            },
        },
        // breakpoints: {
        //     [window.gridBreakpoints.lg]: {
        //         perPage: 8.5,
        //         perMove: 1,
        //         focus: 'center',
        //         trimSpace: true,
        //         fixedWidth: null,
        //     },
        // },
    },
    collection_section: {
        fixedWidth: '288px',
        fixedHeight: 'auto',
        perPage: 1.2,
        gap: '12px',
        focus: 'start',
        padding: {
            right: '14px',
        },
        loop: false,
        arrows: false,
        pagination: false,
        lazyLoad: 'nearby',
    },

    recommendations: {
        fixedWidth: '320px',
        focus: 'center',
        arrows: false,
        pagination: false,
    },

    // product page
    clientPhotos: {
        type: 'fade',
        rewind: true,
        autoplay: true,
        interval: 3000,
        arrows: false,
        pagination: false,
        lazyLoad: 'nearby',
    },
    opinions: {
        fixedWidth: '270px',
        fixedHeight: '300px',
        focus: 'center',
        arrows: false,
        pagination: false,
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                fixedWidth: '460px',
            },
        },
    },
    productGalleryMobile: {
        pagination: false,
        customNoDrag: true,
        lazyLoad: 'nearby',
        gap: '0px',
    },
    underheaderbar: {
        perPage: 1,
        autoplay: true,
        arrows: false,
        pagination: false,
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                perPage: 3,
                autoplay: false,
            },
        },
    },
    savickiCareTopbar: {
        autoplay: true,
        arrows: false,
        pagination: false,
        fixedWidth: '180px',
    },
    navigationDesktop: {
        perPage: 5,
        perMove: 1,
        autoplay: true,
        pagination: false,
        arrows: true,
        classes: {
            prev: 'splide__custom-arrow--prev',
            next: 'splide__custom-arrow--next',
        },
        fixedWidth: '152px',
        lazyLoad: 'sequential',
        gap: '12px',
    },
    navigationDesktopNoArrow: {
        perPage: 5,
        perMove: 1,
        autoplay: true,
        loop: true,
        pagination: false,
        arrows: false,
        fixedWidth: '152px',
        lazyLoad: 'sequential',
        gap: '12px',
    },
    navigationCollectionDesktop: {
        perPage: 3,
        perMove: 3,
        autoplay: true,
        pagination: false,
        fixedWidth: '432px',
        lazyLoad: 'sequential',
        classes: {
            prev: 'splide__custom-arrow--prev',
            next: 'splide__custom-arrow--next',
        },
        // focus: 'center',
        // drag: 'free',
        gap: '12px',
        breakpoints: {
            [window.gridBreakpoints.md]: {
                perPage: 2,
            },
        },
    },
    navigationMostlyChoosenDesktop: {
        perPage: 5,
        perMove: 1,
        autoplay: true,
        pagination: false,
        fixedWidth: '224px',
        lazyLoad: 'sequential',
        classes: {
            prev: 'splide__custom-arrow--prev',
            next: 'splide__custom-arrow--next',
        },
        // focus: 'center',
        // drag: 'free',
        gap: '32px',
    },
    fairytaleLanding: {
        perPage: 4,
        perMove: 1,
        autoplay: false,
        pagination: false,
        // gap: '4px',
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                perPage: 6,
            },
        },
    },
    returnsSlider: {
        perPage: 1,
        perMove: 1,
        reqind: true,
        autoplay: true,
        // pagination: true,
        arrows: false,
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                perPage: 3,
            },
        },
    },
    returnsOtherSlider: {
        perPage: 1,
        rewind: true,
        perMove: 1,
        autoplay: true,
        arrows: false,
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                perPage: 4,
            },
        },
    },
    productGalleryMobileThumbs: {
        perPage: 5,
        rewind: true,
        perMove: 1,
        autoplay: true,
        interval: 3000,
        arrows: false,
        pagination: false,
        lazyLoad: 'nearby',
        gap: '12px',
    },
    usps: {
        // perPage: 1,
        pagination: false,
        arrows: false,
        autoplay: true,
        interval: 3000,
        fixedWidth: '100%',
        breakpoints: {
            [window.gridBreakpoints.xl]: {
                // perPage: 5,
                gap: '48px',
                fixedWidth: 'auto',
                // autoWidth: true,
            },
        },
    },
    home_collections: {
        // perPage: 4,
        arrows: false,
        autoplay: true,
        rewind: true,
        interval: 5000,
        pagination: false,
        // fixedWidth: 'auto',
        autoWidth: true,
        gap: '12px',
        padding: {
            right: '24px',
        },
    },
    product_tabs: {
        arrows: false,
        rewind: false,
        pagination: false,
        autoWidth: true,
        gap: '8px',
        drag: 'free',
    },
    faq_tabs: {
        arrows: false,
        rewind: true,
        pagination: false,
        autoWidth: true,
        gap: '10px',
    },
    home_categories: {
        perPage: 1,
        pagination: false,
        arrows: true,
        fixedWidth: '240px',
        fixedHeight: '360px',
        lazyLoad: 'nearby',
        autoplay: false,
        classes: {
            prev: 'splide__custom_v2-arrow--prev',
            next: 'splide__custom_v2-arrow--next',
        },
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                perPage: 3,
            },
        },
        gap: '16px',
    },
    savicki_benefits: {
        perPage: 2,
        type: 'loop',
        pagination: false,
        autoplay: true,
        arrows: false,
        rewind: true,
        fixedWidth: 'auto',
        interval: 5000,
        lazyLoad: 'nearby',
        breakpoints: {
            [window.gridBreakpoints.sm]: {
                perPage: 2,
                padding: {
                    right: '30%',
                },
            },
            [window.gridBreakpoints.md]: {
                perPage: 3,
                padding: {
                    right: '30%',
                },
            },
            [window.gridBreakpoints.lg]: {
                perPage: 4,
                padding: {
                    right: '10%',
                },
            },
        },
    },
    desktop_navigation: {
        perPage: 'auto',
        arrows: false,
        autoplay: false,
        pagination: false,
        autoWidth: true,
        gap: '12px',
        focus: 'end',
        trimSpace: false,
        drag: 'free',
        start: 0,
        width: '100%',
        breakpoints: {
            [window.gridBreakpoints.md]: {
                perPage: 5,
            },
            [window.gridBreakpoints.xl]: {
                perPage: 7,
            },
        },
    },
    main_categories: {
        perPage: 1,
        pagination: false,
        arrows: false,
        fixedWidth: '240px',
        lazyLoad: 'nearby',
        autoplay: false,
        gap: '16px',
        padding: {
            right: '14px',
        },
    },
    product_description_tiles: {
        perPage: 1,
        pagination: false,
        arrows: false,
        fixedWidth: '288px',
        lazyLoad: 'nearby',
        autoplay: false,
        gap: '12px',
    },
    product_description: {
        perPage: 1,
        perMove: 3,
        arrows: true,
        autoplay: false,
        pagination: false,
        autoWidth: true,
        gap: '24px',
        classes: {
            prev: 'splide__custom-arrow--prev',
            next: 'splide__custom-arrow--next',
        },
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                perPage: 1,
                perMove: 3,
            },
        },
    },
    product_description_carat: {
        perPage: 1,
        perMove: 5,
        arrows: true,
        autoplay: false,
        pagination: false,
        autoWidth: true,
        gap: '4px',
        classes: {
            prev: 'splide__custom-arrow--prev',
            next: 'splide__custom-arrow--next',
        },
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                perPage: 1,
                perMove: 5,
            },
        },
    },
    footer_written: {
        perPage: 2,
        arrows: false,
        gap: '48px',
        autoplay: true,
        interval: 3000,
        pagination: false,
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                fixedWidth: 1300 / 7,
            },
        },
    },
    footer_awards: {
        perPage: 2,
        arrows: false,
        autoWidth: true,
        autoplay: true,
        gap: '15px',
        interval: 3000,
        pagination: false,
        breakpoints: {
            [window.gridBreakpoints.xl]: {
                perPage: 4,
            },
            [window.gridBreakpoints.lg]: {
                perPage: 3,
            },
        },
    },

    productItemCarousel: {
        perPage: 1,
        perMove: 1,
        arrows: false,
        pagination: true,
        lazyLoad: 'nearby',
    },
    desktopNavigationCollections: {
        // perPage: 5,
        fixedWidth: '208px',
        pagination: false,
        arrows: true,
        classes: {
            prev: 'splide__custom-arrow--prev',
            next: 'splide__custom-arrow--next',
        },
    },
    desktopNavigationCollectionSlider: {
        // perPage: 5,
        fixedWidth: '132px',
        pagination: false,
        arrows: true,
        classes: {
            prev: 'splide__custom-arrow--prev',
            next: 'splide__custom-arrow--next',
        },
    },
    footerYourStories: {
        fixedWidth: '250px',
        pagination: false,
        arrows: false,
        gap: 0,
    },
    homeOurSpecials: {
        perPage: 2,
        perMove: 1,
        pagination: false,
        arrows: true,
    },
    opineoReviews: {
        fixedWidth: '280px',
        autoHeight: true,
        arrows: true,
        pagination: false,
        gap: '16px',
        trimSpace: 'move',
        classes: {
            prev: 'splide__opineo-arrow--prev',
            next: 'splide__opineo-arrow--next',
        },
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                fixedWidth: '320px',
            },
        },
    },
    sliderTopbar: {
        type: 'loop',
        perPage: 1,
        autoplay: true,
        interval: 4000,
        arrows: true,
        pagination: false,
        gap: 0,
    },
    socialProofMarkets: {
        fixedWidth: '180px',
        autoHeight: true,
        arrows: true,
        pagination: false,
        gap: '16px',
        trimSpace: 'move',
        classes: {
            prev: 'splide__opineo-arrow--prev',
            next: 'splide__opineo-arrow--next',
        },
        breakpoints: {
            [window.gridBreakpoints.lg]: {
                fixedWidth: '200px',
            },
        },
    },
};

// each seperate config extends common config
Object.keys(CONFIG).forEach((key) => {
    CONFIG[key] = {
        ...COMMON_CONFIG,
        ...CONFIG[key],
    };
});

export default CONFIG;
